import posNotificationInstance from '../instance'

const updateNotificationDevice = (id, data) => {
	return posNotificationInstance.put(`devices/${id}`, data)
}

export default updateNotificationDevice
